// extracted by mini-css-extract-plugin
export default {"actionsHeader":"tanstack-table-module__actionsHeader--rxwVO","actionsCell":"tanstack-table-module__actionsCell--qQcFU"};